export default {
  title: 'Bun venit',
  subtitle: 'Conectează-te pentru a gestiona contul și comenzile',
  benefits: {
    earn_points: {
      title: 'Câștigă puncte la fiecare comandă',
      description: 'Colectează puncte și deblochează recompense exclusive',
    },
    get_deals: {
      title: 'Primește reduceri exclusive',
      description: 'Folosește punctele pentru articole gratuite',
    },
    redeem_points: {
      title: 'Schimbă punctele pentru mâncare gratuită',
      description: 'Accesează promoții exclusive pentru membri',
    },
  },
};
